/**
 * Phone numbers as the WhatsApp Cloud API reports senders: digits only,
 * international form, no '+' (2348031234567). Nigerian-first: accepts what
 * owners actually type — 0803 123 4567, +234 803-123-4567, 803 123 4567.
 * Returns null when it isn't a plausible number. Never a key (CLAUDE.md #9):
 * used only to compare an invite with the number that answers it.
 */
export function normalizePhone(raw: string): string | null {
  const digits = raw
    .replace(/\D/g, '')
    .replace(/^00/, '') // international dialling prefix in place of '+'
    .replace(/^2340(?=[789][01]\d{8}$)/, '234'); // trunk 0 kept after the country code: +234 (0)803…
  if (/^0[789][01]\d{8}$/.test(digits)) return `234${digits.slice(1)}`; // 0803…, local with trunk 0
  if (/^[789][01]\d{8}$/.test(digits)) return `234${digits}`; // 803…, trunk 0 dropped
  if (/^234[789][01]\d{8}$/.test(digits)) return digits;
  if (/^[1-9]\d{9,14}$/.test(digits)) return digits; // already international (any country)
  return null;
}
